import { DialogVariantEnum } from 'enums/dialogVariant';
import { XTMJobStatus } from './restApplicationClient';

/**
 * Returns required job statuses based on displayed dialog variant
 *
 * @param variant - Dialog variant
 *
 * @returns {Array<string>} - Array of statuses which can perform variant operation
 */
export const getRequiredJobStatuses = (variant?: DialogVariantEnum): Array<XTMJobStatus> => {
  const requiredStatuses: Array<XTMJobStatus> = [];
  switch (variant) {
    case DialogVariantEnum.IMPORT: {
      requiredStatuses.push('FINISHED');
      break;
    }
    case DialogVariantEnum.SEND: {
      requiredStatuses.push('NEW');
      break;
    }
    case DialogVariantEnum.CANCEL: {
      requiredStatuses.push('NEW', 'IN_PROGRESS', 'SENT');
      break;
    }
    case DialogVariantEnum.DELETE: {
      requiredStatuses.push('CANCELLED');
      break;
    }
    case DialogVariantEnum.ADD_LANGUAGES:
    case DialogVariantEnum.CHANGE_DUE_DATE_PROJECT:
    case DialogVariantEnum.CHANGE_DUE_DATE_JOB:
    case DialogVariantEnum.REMOVE_LANGUAGES: {
      requiredStatuses.push('NEW', 'SENT', 'IN_PROGRESS');
      break;
    }
    default: {
      requiredStatuses.push('NEW', 'SENT', 'IN_PROGRESS', 'CANCELLED', 'FINISHED');
      break;
    }
  }
  return requiredStatuses;
};
